<template>
  <footer class="footer">
    <div>
      <p>
        <strong>小破站</strong>© 2021-2030
        <a href="https://stock.mephisto.cc">mephisto</a>. The source code is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer",
};
</script>

<style scoped>
footer {
  display: flex;
  justify-content: center;
  padding: 5px;
  background-color: #545c64;
  color: #fff;
}
</style>